import { render, staticRenderFns } from "./ToDoDetailsSidebar.vue?vue&type=template&id=72fb8d0f"
import script from "./ToDoDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./ToDoDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToDoDetailsSidebar.vue?vue&type=style&index=0&id=72fb8d0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports